import { getFormattedDeviceDetails } from '@utils/DeviceDetailsUtil';
import { track } from '@utils/MixPanelUtils';

import { CALL_API } from '../middleware/ApiMiddleware';

export const SEARCH_VIOLATION_ENTITY_REQUEST = 'SEARCH_VIOLATION_ENTITY_REQUEST';
export const SEARCH_VIOLATION_ENTITY_SUCCESS = 'SEARCH_VIOLATION_ENTITY_SUCCESS';
export const SEARCH_VIOLATION_ENTITY_FAILURE = 'SEARCH_VIOLATION_ENTITY_FAILURE';
export const LOAD_MORE_VIOLATION_ENTITIES = 'LOAD_MORE_VIOLATION_ENTITIES';
export const CLEAR_VIOLATION_ENTITIES = 'CLEAR_VIOLATION_ENTITIES';

export const FETCH_ENTITY_LIST_REQUEST = 'FETCH_ENTITY_LIST_REQUEST';
export const FETCH_ENTITY_LIST_SUCCESS = 'FETCH_ENTITY_LIST_SUCCESS';
export const FETCH_ENTITY_LIST_FAILURE = 'FETCH_ENTITY_LIST_FAILURE';
export const LOAD_MORE_ENTITIES = 'LOAD_MORE_ENTITIES';

export const DOWNLOAD_ENTITIES_LIST_CSV_REQUEST = 'DOWNLOAD_ENTITIES_LIST_CSV_REQUEST';
export const DOWNLOAD_ENTITIES_LIST_CSV_SUCCESS = 'DOWNLOAD_ENTITIES_LIST_CSV_SUCCESS';
export const DOWNLOAD_ENTITIES_LIST_CSV_FAILURE = 'DOWNLOAD_ENTITIES_LIST_CSV_FAILURE';

const baseURL = 'xerce/violation/entities';

export const searchViolationEntities = (params: IViolationEntitySearchParams) => {
  if (!params.offset) {
    track('KEYWORD_SEARCH', {
      'Device Details': getFormattedDeviceDetails(),
    });
  }

  return {
    [CALL_API]: {
      endpoint: baseURL,
      params,
      method: 'get',
      authenticated: true,
      hideLoadingWidget: true,
      types: [
        SEARCH_VIOLATION_ENTITY_REQUEST,
        params.offset && params.offset > 0 ? LOAD_MORE_VIOLATION_ENTITIES : SEARCH_VIOLATION_ENTITY_SUCCESS,
        SEARCH_VIOLATION_ENTITY_FAILURE,
      ],
    },
  };
};

export const clearViolationEntities = () => ({
  type: CLEAR_VIOLATION_ENTITIES,
});

export const fetchEntityList = (
  agencyId: number,
  reqParams: IEntityListRequestParams,
  replaceResults: boolean = false
) => {
  const params: IEntityListRequestParams = { ...reqParams };
  const { offset } = params;

  return {
    [CALL_API]: {
      endpoint: `agencies/${agencyId}/xerce/entities`,
      params,
      method: 'get',
      authenticated: true,
      types: [
        FETCH_ENTITY_LIST_REQUEST,
        offset && offset > 0 && !replaceResults ? LOAD_MORE_ENTITIES : FETCH_ENTITY_LIST_SUCCESS,
        FETCH_ENTITY_LIST_FAILURE,
      ],
      hideLoadingWidget: true,
    },
  };
};

export const downloadEntitiesListCSV = (params: IEntityListRequestParams, sendEmail: boolean = false) => {
  const queryParams: any = {};
  queryParams.sendEmail = sendEmail;

  return {
    [CALL_API]: {
      endpoint: `${baseURL}/download`,
      method: 'post',
      params: queryParams,
      body: params,
      authenticated: true,
      types: [
        DOWNLOAD_ENTITIES_LIST_CSV_REQUEST,
        DOWNLOAD_ENTITIES_LIST_CSV_SUCCESS,
        DOWNLOAD_ENTITIES_LIST_CSV_FAILURE,
      ],
    },
  };
};
